import React from 'react';
import { Field } from 'formik';
import { Grid } from '@material-ui/core';

import { AssetHistoryForm } from 'features/equipment/assets/components/equipmentTest/form-utils/AssetHistoryForm';
import QuantityTextFieldFormik from 'app/components/form/formik/QuantityTextFieldFormik';

const CableCutMaintenanceFormComponent = () => {
  return (
    <>
      <Grid container>
        <Grid item xs={12} container>
          <Field
            type="number"
            label="Distance"
            component={QuantityTextFieldFormik}
            name={AssetHistoryForm.CABLE_CUT_MAINTENANCE_DISTANCE}
            placeholder="0"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CableCutMaintenanceFormComponent;
